import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'

import ErrorIllustration from 'core/ui/assets/illustration-generic-error.svg'

export type ErrorShipmentChargesStateProps = {
  onRefetchCharges: () => void
}

export function ErrorShipmentChargesState({ onRefetchCharges }: ErrorShipmentChargesStateProps) {
  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderWidth="border-thin"
      borderColor="color-border"
      borderRadius="border-radius-s"
      padding="spacing-10"
    >
      <Layout.Group align="center" justify="center">
        <EmptyState
          variant="panel"
          illustration={ErrorIllustration}
          title="Something went wrong"
          description="Sorry, something went wrong and we couldn't load the charges, please refresh to try again."
          action={{
            label: 'Try again',
            onClick: onRefetchCharges,
          }}
        />
      </Layout.Group>
    </Layout.Box>
  )
}
